module.exports = __webpack_public_path__ + "img/fuerza-2011.4fdb02ee.png";